<template>
  <div class="gk-modal" :class="{open: show}" >
    <div class="modal-layer" @click="clickLayer"></div>
    <div class="content" :style="{width:width}">
      <div class="close-btn iconfont" @click="close" v-if="hasClose">&#xe60a;</div>
      <div class="title">
        {{title}}
      </div>
      <div class="main-body">
        <slot name="content"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../utils'
export default {
  name: 'modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '70%'
    },
    closeOnClickLayer: {
      type: Boolean,
      default: false
    },
    hasClose: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    show (val) {
      val ? utils.fixedBody.open() : utils.fixedBody.close()
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    clickLayer () {
      if (this.closeOnClickLayer) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/common";
.gk-modal {
  position: fixed; z-index: 1000; top: 0; bottom: 0; left: 0; right: 0;
  @extend %center;
  opacity: 0;
  pointer-events: none;
  @extend %transition;
  
  &.open {
    pointer-events: auto;
    opacity: 1;

    & .content {
      transform: scale(1);
    }

    & .modal-layer {
      opacity: 1;
    }
  }
  & .modal-layer {
    position: absolute; z-index: 1001; top: 0; bottom: 0; left: 0; right: 0;
    background: rgba(0, 0, 0, 0.6);
    opacity: 0;
    @extend %transition;
  }

  & .content {
    box-sizing: border-box;
    position: relative; top: -30px; z-index: 1002;
    // padding: 50px;
    background: #ffffff;
    border-radius: 4px;
    @extend %transition;
    transform: scale(0.6);

    & .title {
      @include lineFont(24, 400);
      text-align: center;
    }

    & .close-btn {
      position: absolute; top: 15px; right: 15px;
      width: 20px; height: 20px;
      @extend %font12;
      text-align: center;
      cursor: pointer;
    }

    & .main-body {
      @extend %center;
    }
  }
  .footer {
    @extend %center;
  }
  
}
</style>


